import * as React from 'react';
import { connect } from 'react-redux';
import { StepWizardHost } from 'sos-common/js/components/WizardStepper/WizzardStepperHost';
import { MessageBanner } from 'sos-common/js/components/MessageBanner/messageBanner';
import { FormWrapper } from 'sos-eservice-common/js/components/FormWrapper/FromWrapper';
import { StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { StepOne, StepTwo, StepThree, StepFour, StepFive } from './steps';
import {
  ResearchOrderStore,
  researchOrderGlobals
} from '../../models/ResearchOrderStore.types';
import { closeMessageBar, setCurrentStep } from 'sos-eservice-common/js/Redux/Actions';
import { WizardHostStat } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { translateFunc, makeTranslator } from '../../utilities/translations';
export interface ResearchOrderFormProps {
  stepValidationMap: StepValidationMap;
  showSavedBanner: boolean;
  closeMessageBar: typeof closeMessageBar;
  setCurrentStep: typeof setCurrentStep;
  Translate?: translateFunc;
}

class ResearchOrderForm extends React.Component<ResearchOrderFormProps, any> {
  public onCloseMessageBar = () => {
    this.props.closeMessageBar();
  }

  public handleStepChange = (stat: WizardHostStat) => {
    this.props.setCurrentStep(stat);
  }
  public render() {
    const { Translate } = this.props;
    return (
      <React.Fragment>
        {this.props.showSavedBanner && (
          <MessageBanner onClose={this.onCloseMessageBar} />
        )}
        <FormWrapper heading={Translate('/orderFormPage/orderFormHeader')}>
          <StepWizardHost
            onStepChange={this.handleStepChange}
            stepValidationMap={this.props.stepValidationMap}
            nextLabel='Nästa steg'
            previousLabel='Föregående steg'
            classNamesForFocusInput='step animated'
          >
            {/* todo: insert <p>@Html.Translate("/orderFormPage/starOblig")</p> here */}
            <StepOne />
            <StepTwo />
            <StepThree />
            <StepFour />
            <StepFive />
          </StepWizardHost>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    stepValidationMap: state.validationState.stepValidationMap,
    showSavedBanner: state.globals.showSavedBanner
  } as ResearchOrderFormProps;
};

const mapDispatch2Props = {
  closeMessageBar,
  setCurrentStep
};

export default connect(
  mapState2Props,
  mapDispatch2Props
)(ResearchOrderForm);
